import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const inputField = this.element.querySelector("textarea");

    this.element.addEventListener("focus", () => {
      if (this.element.value == "") {
        this.element.value = this.element.placeholder;
      }
    });

    this.element.addEventListener("blur", () => {
      if (this.element.value == this.element.placeholder) {
        this.element.value = "";
      }
    });
  }
}
